import React, { useMemo } from 'react';
import PreviewImage from '../../PreviewImage';
import currency from 'currency.js';
import { Link } from 'react-router-dom';
import Button from '../../Button/v2';
import styles from './CartItem.module.scss';
import routes from '../../../routes';

export default function AddonPackage({ editable, orderPackage, removeItem }) {
  const foregroundUrl = orderPackage.addonSheets[0].pose.imageUrl;
  const backgroundUrl = orderPackage.addonSheets[0].background.imageUrl;

  const subtotal = useMemo(() => (
    orderPackage.addonSheets.reduce((acc, cur) => acc + (cur.addon.priceWithout || cur.addon.priceWith), 0)
  ));

  const addonCount = useMemo(() => (
    orderPackage.addonSheets.reduce((acc, cur) => {
      const currentCount = acc[cur.addonId.toString()] || 0;

      return { ...acc, [cur.addonId.toString()]: currentCount + 1 };
    }, {})
  ));

  const addonsById = useMemo(() => (
    orderPackage.addonSheets.reduce((acc, cur) => {
      if (acc[cur.addonId.toString()]) return acc;

      return { ...acc, [cur.addonId.toString()]: cur.addon };
    }, {})
  ));

  const editLink = orderPackage.apiOption.name.toLowerCase().includes('holiday') ? routes.holiday.edit(orderPackage.id) : routes.individualPrintEdit(orderPackage.id);

  return (
    <div className={styles.cartItem}>
      {!orderPackage.apiOption.name.toLowerCase().includes('holiday') && (
        <div className={styles.previewImage}>
          <PreviewImage foregroundUrl={foregroundUrl} backgroundUrl={backgroundUrl} accessCodeOnly={false} />
        </div>
      )}
      <div className={styles.info}>
        <div>
          <p className={styles.packageName}>{orderPackage.apiOption.name}</p>
          <p className={styles.subtotal}>{currency(subtotal).format()}</p>
          <ol className={styles.itemList}>
            {Object.keys(addonCount).map((addonId) => {
              if (!addonsById[addonId]) return null;

              return <li key={addonId}>{`${addonCount[addonId]} ${addonsById[addonId].name}`}</li>;
            })}
          </ol>
        </div>
        {editable && (
          <div className={styles.actions}>
            <Link to={editLink}>Edit</Link>
            <Button className={styles.removeBtn} onClick={() => removeItem(orderPackage.id, 'orderPackage')}>Remove</Button>
          </div>
        )}
      </div>
    </div>
  );
}
